module["exports"] = [
  "Piazza",
  "Strada",
  "Via",
  "Borgo",
  "Contrada",
  "Rotonda",
  "Incrocio"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/street_suffix.js
 ** module id = 761
 ** module chunks = 0
 **/